require("@rails/ujs").start();
require("@rails/activestorage").start();
require("channels");

require("material-kit");
require("main");
